export const defaultTitle = 'OpenTofu and Terraform Registry';

export const providerDescription = 'Providers are a logical abstraction of an upstream API. They are responsible for understanding API interactions and exposing resources.';

export const moduleDescription = 'Modules are self-contained packages of OpenTofu / Terraform configurations that are managed as a group.';
